<template>
  <div
    :class="[
      $style.container,
      {[$style.containerStateOpen]: panelVisible},
      {[$style.containerStyleRight]: align == 'right'},
      {[$style.containerStyleNohover]: !hoverable},
      {[$style.containerStyleArrowless]: !arrow},
      'dropdown'
    ]"
  >
    <a
      v-if="$slots.panel"
      href="#"
      :class="[$style.dropdownButton, {[buttonClass]: buttonClass}]"
      @click.prevent="buttonClickHandler"
    >
      <div :class="$style.dropdownButtonLabel">
        <slot name="label" />
      </div>
      <img
        v-if="arrow"
        src="~@images/dd-arrow.svg"
        alt=""
        :class="$style.dropdownButtonArrow"
        width="13"
        height="8"
      >
    </a>
    <div
      v-else
      :class="[$style.dropdownButton, {[buttonClass]: buttonClass}]"
    >
      <div :class="$style.dropdownButtonLabel">
        <slot name="label" />
      </div>
    </div>
    <transition
      :enter-class="$style.dropdownPanelTransitionState"
      :leave-to-class="$style.dropdownPanelTransitionState"
    >
      <div
        v-if="panelVisible"
        :class="$style.dropdownPanel"
      >
        <div :class="$style.dropdownPanelBody">
          <slot name="panel" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export const EVENT_DROPDOWN_PANEL_SHOW = 'dropdown.panel.show'

  export default {
    props: {
      align: {
        type: String,
        default: 'center'
      },
      hoverable: {
        type: Boolean,
        default: true
      },
      arrow: {
        type: Boolean,
        default: true
      },
      buttonClass: {
        type: String
      }
    },
    data () {
      return {
        panelVisible: false
      }
    },
    beforeDestroy () {
      document.removeEventListener('click', this.documentClickHandler)
      this.$ignoreSystemEvent(EVENT_DROPDOWN_PANEL_SHOW, this.panelShowHandler)
    },
    created () {
      document.addEventListener('click', this.documentClickHandler)
      this.$listenSystemEvent(EVENT_DROPDOWN_PANEL_SHOW, this.panelShowHandler)
    },
    methods: {
      panelShowHandler (e) {
        if (!this.isSameDropdown(e.target)) {
          this.hidePanel()
        }
      },
      documentClickHandler (e) {
        this.hidePanel()
      },
      buttonClickHandler (e) {
        e.stopPropagation()
        this.togglePanel()
      },
      showPanel () {
        this.$set(this, 'panelVisible', true)
        this.$sendSystemEvent(EVENT_DROPDOWN_PANEL_SHOW, { target: this })
        return this
      },
      hidePanel () {
        this.$set(this, 'panelVisible', false)
        return this
      },
      togglePanel () {
        return this[(this.panelVisible) ? 'hidePanel' : 'showPanel']()
      },
      isSameDropdown (dropdownComponent) {
        return dropdownComponent._uid === this._uid
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/mixins";

  /**
   * Container
   */
  .container {
    display: flex;
    position: relative;
  }

  /**
   * Container open state
   */
  .containerStateOpen {
    .dropdownButtonArrow {
      transform: rotate(-180deg);
    }

    .dropdownButton {
      opacity: 1;
    }
  }

  /**
   * Container arrowless style
   */
  .containerStyleArrowless {
    .dropdownPanel:before {
      right: 50%;
      left: auto;
      margin-right: -10px;
    }
  }

  /**
   * Container right aligned style
   */
  .containerStyleRight {
    .dropdownPanelBody {
      right: 5px;
      left: auto;
    }
  }

  /**
   * Container no hover style
   */
  .containerStyleNohover {
    .dropdownButton {
      opacity: 1;
    }
  }

  /**
   * Dropdown button
   */
  .dropdownButton {
    display: flex;
    align-items: center;
    text-decoration: none;
    opacity: .7;
    transition: opacity .3s;
  }

  /**
   * Dropdown button hover state
   */
  .dropdownButton:hover {
    opacity: 1;
  }

  /**
   * Dropdown button label
   */
  .dropdownButtonLabel {
    font-size: 15px;
    color: #2d3e50;
  }

  /**
   * Dropdown button arrow
   */
  .dropdownButtonArrow {
    position: relative;
    display: block;
    width: 13px;
    top: 1px;
    margin-left: 8px;
    transition: transform .3s;
  }

  /**
   * Dropdown panel
   */
  .dropdownPanel {
    position: absolute;
    top: 100%;
    left: 0px;
    width: 100%;
    opacity: 1;
    transition: opacity .3s, transform .2s;

    // Triangle
    &:before {
      position: absolute;
      top: -10px;
      display: block;
      content: '';
      width: 20px;
      height: 20px;
      background-color: #fff;
      transform: rotate(45deg);
      z-index: 1;
    }
  }

  /**
   * Dropdown panel transition state
   */
  .dropdownPanelTransitionState {
    opacity: 0;
    transform: translateY(-20px);
  }

  /**
   * Dropdown panel body
   */
  .dropdownPanelBody {
    position: absolute;
    left: 50%;
    margin-left: -150px;
    overflow: hidden;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0px 8px 45px 0 rgba(26, 35, 46, 0.2);
  }

  /**
   * DESKTOP
   */
  @include desktop {
    .dropdownButton {
      // @todo Padding should be controlled from the outside...
      padding: 0px 25px;
    }

    .dropdownPanel {
      margin-top: -5px;

      // Triangle
      &:before {
        right: 22px;
      }
    }
  }

  /**
   * PHONE
   */
  @include phone {
    .dropdownButton {
      // @todo Padding should be controlled from the outside...
      padding: 0px 15px;
    }

    .dropdownPanel {
      margin-top: 5px;

      // Triangle
      &:before {
        right: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dropdown.vue